// import { useMutation, useQuery } from "@tanstack/react-query";
import { useQuery } from '@tanstack/react-query';
import { useOrderManagementApi } from '../../hooks/useOrderManagementApi';
type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useGetAllOrders = (queryParams: Params) => {
  const { getAllOrders } = useOrderManagementApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getOrders', queryParams],
    queryFn: () => {
      return getAllOrders(queryParams);
    },
    retry: false,
    refetchInterval: 30000, // Auto-refresh every 30 seconds
    refetchIntervalInBackground: true, // Continue refreshing even when tab is not active
  });
  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};
